import '../custom-event-polyfill';
import DocCookies from './doc-cookies';

// cookie black list logic is used here
// if cookie is not mentioned - it won't be removed
class OneTrustHelper {
    public initPromise: Promise<void>;

    private isInitOptanonWrapper: boolean | undefined;

    private lastOnetrustActiveGroups: string | undefined;

    private resolveInitPromise?: () => void;

    constructor() {
        this.registerOptanonWrapper();

        this.initPromise = new Promise(resolve => {
            this.resolveInitPromise = resolve;
        });
    }

    public checkIfCookieNameRestricted(cookieName: string) {
        const otDomainGroups = window['OneTrust']?.['GetDomainData']?.()?.Groups;
        if (!otDomainGroups?.length) return false;

        const activeGroups = window['OnetrustActiveGroups']?.split(',')?.filter(Boolean);

        if (!this.isInitOptanonWrapperComplete) {
            const inactiveGroups = this.inActiveGroupIds;
            return otDomainGroups?.some(otDomainGroup => {
                const curCustomGroupId = otDomainGroup['CustomGroupId'];

                if (!inactiveGroups?.includes(curCustomGroupId)) {
                    return false;
                }

                return otDomainGroup['Cookies']
                    ?.map(({ Name }) => Name)
                    .some(name => name === cookieName);
            });
        }

        if (!activeGroups?.length) return false;

        return otDomainGroups?.some(otDomainGroup => {
            const curCustomGroupId = otDomainGroup['CustomGroupId'];

            if (activeGroups?.includes(curCustomGroupId)) {
                return false;
            }

            return otDomainGroup['Cookies']
                ?.map(({ Name }) => Name)
                .some(name => name === cookieName);
        });
    }

    public get isOneTrustEnabled() {
        return !!window[Symbol.for('oneTrustHash')];
    }

    private initOptanonWrapper() {
        this.isInitOptanonWrapper = true;
        this.lastOnetrustActiveGroups = window['OnetrustActiveGroups'];
    }

    private reloadPage() {
        if (this.lastOnetrustActiveGroups !== window['OnetrustActiveGroups']) {
            const url = new URL(window.location.href);

            url.searchParams.delete('oneTrust');
            window.location.replace(url.href);
        }
    }

    private get isInitOptanonWrapperComplete() {
        return this.isInitOptanonWrapper !== undefined;
    }

    private get inActiveGroupIds() {
        const curOnetrustActiveGroupIds: string[] = window['OnetrustActiveGroups']
            ?.split(',')
            ?.filter(Boolean);
        const otInActiveGroupIds: string[] = [];

        if (!this.isInitOptanonWrapperComplete) {
            const otDomainGroups = window['OneTrust']?.['GetDomainData']?.()?.Groups;

            otDomainGroups?.forEach(otDomainGroup => {
                const curCustomGroupId = otDomainGroup['CustomGroupId'];

                if (!curOnetrustActiveGroupIds?.includes(curCustomGroupId)) {
                    otInActiveGroupIds.push(curCustomGroupId);
                }
            });
        } else {
            const lastOnetrustActiveGroupIds = this.lastOnetrustActiveGroups
                ?.split(',')
                ?.filter(Boolean);

            lastOnetrustActiveGroupIds?.forEach(lastOnetrustActiveGroupId => {
                if (!curOnetrustActiveGroupIds?.includes(lastOnetrustActiveGroupId)) {
                    otInActiveGroupIds.push(lastOnetrustActiveGroupId);
                }
            });
        }

        return otInActiveGroupIds;
    }

    private eraseInActiveCookie(key: string) {
        const domain = window.location.hostname;
        const topLevelDomain = `.${domain.split('.').slice(-2).join('.')}`;

        // Remove top level domain cookie
        DocCookies.removeItem({ key, path: '/', domain: topLevelDomain });
        DocCookies.removeItem({ key, path: '/', domain });
        DocCookies.removeItem({ key, path: '/' });

        //Check for the current path of the page
        const paths = window.location.pathname.split('/').filter(Boolean);

        //Loop through path hierarchy and delete potential cookies at each path.
        paths.forEach((_, i) => {
            //Build the path string from the Path Array e.g /site/login
            const path = paths.slice(0, i + 1).join('/');

            DocCookies.removeItem({ key, path, domain: topLevelDomain });
            DocCookies.removeItem({ key, path, domain });
            DocCookies.removeItem({ key, path });
            //Maybe path has a trailing slash!
            DocCookies.removeItem({ key, path: `${path}/`, domain: topLevelDomain });
            DocCookies.removeItem({ key, path: `${path}/`, domain });
            DocCookies.removeItem({ key, path: `${path}/` });
        });
    }

    private deleteInActiveCookie() {
        const otDomainGroups = window['OneTrust']?.['GetDomainData']?.()?.Groups;
        const inActiveGroupIds = this.inActiveGroupIds;

        if (inActiveGroupIds.length > 0 && otDomainGroups.length > 0) {
            otDomainGroups?.forEach(otDomainGroup => {
                const curCustomGroupId = otDomainGroup['CustomGroupId'];

                if (inActiveGroupIds?.includes(curCustomGroupId)) {
                    otDomainGroup['Cookies']?.forEach(currentCookie =>
                        this.eraseInActiveCookie(currentCookie['Name'])
                    );
                }
            });
        }
    }

    private registerOptanonWrapper() {
        window['OptanonWrapper'] = () => {
            window.dispatchEvent(new CustomEvent('OneTrustLoaded'));

            this.deleteInActiveCookie();

            if (!this.isInitOptanonWrapperComplete) this.initOptanonWrapper();

            if (this.resolveInitPromise) this.resolveInitPromise();

            this.reloadPage();
        };
    }
}

window[Symbol.for('OneTrustHelper')] = new OneTrustHelper();
